import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

let IconBanner = (props) => {
  props = Object.assign({viewBox: '0 0 32 32'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M15.467 4.622h1.067v3.644h-1.067v-3.644z"/>
        <path d="M16.711 26.311v-3.733h-1.067v3.733h-1.689v1.067h4.356v-1.067z"/>
        <path d="M29.778 23.2h-27.556v-15.822h27.467v15.822zM3.378 22.044h25.244v-13.6h-25.244v13.6z"/>
      </g>
    </SvgIcon>
  );
};

IconBanner.displayName = 'IconBanner';
IconBanner.muiName = 'SvgIcon';

export default IconBanner;



// WEBPACK FOOTER //
// ./src/components/Icons/IconBanner.js